const key = "add-readonly-text-field";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const depredationSection = {
	Id: -1,
	Code: "64af3118-78df-49da-9638-733e991a4aaf",
	Name: "ROTF",
	Order: 4.5
};

const readonlytextfield = {
	Id: -1, 
	Name: "Readonly Value",
	Order: 25,
	Section: { Code: "64af3118-78df-49da-9638-733e991a4aaf", Id: -1 },
	Template: "ReadOnlyTextInput",
	Description: "Readonly Text",
	Type: { Code: "STRING" },
	Key: { Code: "READONLYTEXT" }
};

const modify = (resp) => {
	const fields = resp.data.Data.Fields;
	const sections = resp.data.Data.Sections;
	
	sections.push(depredationSection);
	fields.push(readonlytextfield);

	// console.log("added fields", resp.data.Data);
	return resp;
};

export const addReadonlyTextField = [key, applicable, modify];